import type { PortfolioCapitalBasis } from '@einhaus/project314-types';

export const capitalBasisLabels: Record<PortfolioCapitalBasis, string> = {
    cash: 'Cash',
    cashSecuredPut: 'Cash-Secured Puts',
    nakedEquityPut: 'Margin-Backed Short Puts',
    longOptionPremium: 'Long Option Premium',
    definedRiskOption: 'Defined-Risk Options'
};
